import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AccessRestrictionPage } from './access-restriction/access-restriction.page';
import { AuthGuard } from './core/guards/auth.guard';
import { UndoUnportedUserGuard } from './core/guards/undo-unported-user.guard';
import { UndoVersionGuard } from './core/guards/undo-version.guard';
import { UnportedUserGuard } from './core/guards/unported-user.guard';
import { VersionGuard } from './core/guards/version.guard';
import { MaintenanceScreenPage } from './maintenance-screen/maintenance-screen.page';
import { UpgradeScreenPage } from './upgrade-screen/upgrade-screen.page';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'calendar',
    pathMatch: 'full',
  },
  {
    path: 'calendar',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomePageModule),
    canActivate: [AuthGuard, VersionGuard, UnportedUserGuard],
  },
  {
    path: 'calendar/:id',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomePageModule),
    canActivate: [AuthGuard, VersionGuard, UnportedUserGuard],
  },
  {
    path: 'style',
    loadChildren: () =>
      import('./style-guide/style-guide.module').then(
        (m) => m.StyleGuidePageModule
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'selectie-spatiu',
    loadChildren: () =>
      import('./selectie-spatiu/selectie-spatiu.module').then(
        (m) => m.SelectieSpatiuPageModule
      ),
    canActivate: [AuthGuard, VersionGuard, UnportedUserGuard],
  },
  {
    path: 'data-statistice',
    canActivate: [AuthGuard, VersionGuard, UnportedUserGuard],
    loadChildren: () => import('./data-statistice/data-statistice.module').then( m => m.DataStatisticePageModule)
  },
  {
    path: 'app-maintenance',
    component: MaintenanceScreenPage,
    canActivate: [UndoVersionGuard],
    data: {
      title: 'Maintenance',
      noMenu: true,
    }
  },
  {
    path: 'no-access',
    component: AccessRestrictionPage,
    canActivate: [UndoUnportedUserGuard],
    data: {
      title: 'No Access',
      noMenu: true,
    }
  },
  {
    path: 'app-upgrade',
    component: UpgradeScreenPage,
    canActivate: [UndoVersionGuard],
    data: {
      title: 'Upgrade',
      noMenu: true,
    }
     }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
